export enum IoEventTypes {
    DEVICE_VALUES = 'device-values',
    TAG_VALUES = 'tag-values',
    ALARMS_STATUS = 'alarms-status',
    FREQUENCY_VALUE = 'frequency-value',
    DEVICE_FLAGS = 'device-flags',
    SIMULATOR_ACTIVE = 'simulator-active',
    SYSTEM_STATUS_UPDATED = 'system-status-updated',
}

export enum CustomGraphSocketCommands {
    GRAPH_CREATED = 'custom-graph-created',
    GRAPH_DELETED = 'custom-graph-deleted',
    GRAPH_UPDATED = 'custom-graph-updated',
}

export enum TrendGraphSocketCommands {
    GRAPH_CREATED = 'trend-graph-created',
    GRAPH_DELETED = 'trend-graph-deleted',
    GRAPH_UPDATED = 'trend-graph-updated',
}

export enum CustomGroupSocketCommands {
    GROUP_CREATED = 'custom-group-created',
    GROUP_DELETED = 'custom-group-deleted',
    GROUP_UPDATED = 'custom-group-updated',
}

export enum DashboardSocketCommands {
    PANEL_CREATED = 'panel-created',
    PANEL_DELETED = 'panel-deleted',
    PANEL_UPDATED = 'panel-updated',
}

export enum ChannelSocketCommands {
    LIST_UPDATED = 'list-updated',
    CHANNEL_UPDATED = 'channel-updated',
}

export enum SystemStatusSocketCommands {
    STATUS_UPDATED = 'system-status-updated',
    STATUS_DISCONNECTED = 'system-status-disconnected',
    STATUS_CONNECTED = 'system-status-connected',
}
